import jsPDF from "jspdf";

const PrintKitchenCard = (order) => {
  const paperWidth = 58;
  const pageHeight = 200;
  const marginLeft = 5;
  const checkboxSize = 4;
  const optCheckboxSize = 3;
  const space = 2;

  const createdDate = new Date(order.createdAt || Date.now());
  const mm = String(createdDate.getMonth() + 1).padStart(2, "0");
  const dd = String(createdDate.getDate()).padStart(2, "0");
  const yyyy = createdDate.getFullYear();
  const formattedDate = `${mm}-${dd}-${yyyy}`;
  const filename = `${formattedDate}-${order.orderNumber}.pdf`;

  let doc = new jsPDF({
    orientation: "portrait",
    unit: "mm",
    format: [paperWidth, pageHeight],
  });

  const header = () => {
    let y = 10;

    doc.setFontSize(10);
    doc.setFont("helvetica", "bold");
    doc.text(`Order #: ${order.orderNumber}`, marginLeft, y);

    doc.setFontSize(18);
    let statusText = "TO";
    let statusColor = "#0277bd";
    if (
      typeof order.tentNumber === "string" &&
      order.tentNumber.toLowerCase().includes("fmeal")
    ) {
      statusText = "FM";
      statusColor = "#c792ea";
    } else if (order.salesType === "Dine-In") {
      statusText = "DI";
      statusColor = "#2e7d32";
    } else if (order.salesType === "Delivery") {
      statusText = "DEL";
      statusColor = "orange";
    }

    const rightMargin = 4;
    const statusWidth = doc.getTextWidth(statusText);
    const statusX = Math.max(
      marginLeft,
      paperWidth - rightMargin - statusWidth - 1
    );

    doc.setTextColor(statusColor);
    doc.text(statusText, statusX, y + 2);
    doc.setTextColor(0);

    y += 6;
    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");
    doc.text(`Tent #: ${order.tentNumber}`, marginLeft, y);
    y += 4;

    doc.setFontSize(8);
    doc.text("----------------------------------", paperWidth / 2, y, {
      align: "center",
    });
    y += 8;

    return y;
  };

  const measureItemHeight = (item) => {
    const measurer = new jsPDF({ unit: "mm" });
    const textX = marginLeft + checkboxSize + space;
    const maxNameWidth = paperWidth - textX - 2;
    measurer.setFont("helvetica", "bold");
    measurer.setFontSize(11);
    const nameWrapped = measurer.splitTextToSize(
      `${item.amount}pc/s - ${String(item.name ?? "").trim()}`,
      maxNameWidth
    );
    let optionsLines = 0;
    if (Array.isArray(item.options) && item.options.length > 0) {
      const optCheckX = textX + 1;
      const optTextX = optCheckX + optCheckboxSize + space;
      const maxOptWidth = paperWidth - optTextX - 2;
      measurer.setFont("helvetica", "normal");
      measurer.setFontSize(9);
      item.options.forEach((opt) => {
        const choices = Array.isArray(opt.choices)
          ? opt.choices.map((c) => String(c).trim()).join(", ")
          : opt.value ?? "";
        const line = `${opt.name}: ${String(choices).trim()}`.trim();
        const lines = measurer.splitTextToSize(line, maxOptWidth);
        optionsLines += lines.length;
      });
    }
    const lineHeight = 4.5;
    const optLineHeight = 4;
    const itemBlock = lineHeight + nameWrapped.length * lineHeight + 2;
    const optsBlock = optionsLines * optLineHeight + (optionsLines > 0 ? 2 : 0);
    const spacingAfter = 6;
    return itemBlock + optsBlock + spacingAfter;
  };

  let y = header();

  for (let index = 0; index < order.items.length; index++) {
    const item = order.items[index];

    const needed = measureItemHeight(item);
    if (y + needed > pageHeight - 10) {
      doc.addPage([paperWidth, pageHeight]);
      y = header();
    }

    const textX = marginLeft + checkboxSize + space;
    const maxNameWidth = paperWidth - textX - 2;

    doc.rect(marginLeft, y - 3, checkboxSize, checkboxSize);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(11);

    const nameWrapped = doc.splitTextToSize(
      `${item.amount}pc/s - ${String(item.name ?? "").trim()}`,
      maxNameWidth
    );

    const lineHeight = 4.5;
    nameWrapped.forEach((line, i) => {
      doc.text(line, textX, y + i * lineHeight);
    });

    y += nameWrapped.length * lineHeight + 2;

    if (Array.isArray(item.options) && item.options.length > 0) {
      const optCheckX = textX + 1;
      const optTextX = optCheckX + optCheckboxSize + space;
      const maxOptWidth = paperWidth - optTextX - 2;

      doc.setFont("helvetica", "normal");
      doc.setFontSize(9);

      item.options.forEach((opt) => {
        const choices = Array.isArray(opt.choices)
          ? opt.choices.map((c) => String(c).trim()).join(", ")
          : opt.value ?? "";
        const line = `${opt.name}: ${String(choices).trim()}`.trim();
        const optLines = doc.splitTextToSize(line, maxOptWidth);

        doc.rect(optCheckX, y - 3, optCheckboxSize, optCheckboxSize);
        optLines.forEach((l, j) => {
          doc.text(l, optTextX, y + j * 4);
        });
        y += optLines.length * 4 + 1;

        if (y > pageHeight - 10) {
          doc.addPage([paperWidth, pageHeight]);
          y = header();
        }
      });

      y += 1;
    }

    y += 4;

    if (y > pageHeight - 10 && index < order.items.length - 1) {
      doc.addPage([paperWidth, pageHeight]);
      y = header();
    }
  }

  try {
    const blob = doc.output("blob");

    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(blob, filename);
      return;
    }

    const url = URL.createObjectURL(blob);
    let w = window.open(url, "_blank", "noopener");
    if (!w || w.closed) {
      const a = document.createElement("a");
      a.href = url;
      a.target = "_blank";
      a.rel = "noopener";
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }

    setTimeout(() => {
      try {
        URL.revokeObjectURL(url);
      } catch (e) {}
    }, 120000);
  } catch (e) {
    console.error("Error opening PDF blob:", e);
  }
};

export default PrintKitchenCard;
